// import axisLenControlPlugin from "./plugins/axisLenControlPlugin"
import formaterControlLenPlugin from "components/bigScreenComponents/commonPlugins/formaterControlLenPlugin"
export default {
  // mixins: [axisLenControlPlugin]
  mixins: [formaterControlLenPlugin]
}
